export const cards = [
  {
    title: 'Анализ социальных данных',
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ',
    type: ''
  },
  {
    title: 'Инфраструктура больших данных',
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ',
    type: 'mach'
  },
  {
    title: 'Облачные вычисления',
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ',
    type: 'data'
  },
  {
    title: 'QA системы',
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ',
    type: 'robo'
  }
];